export const getRandomElement = (array) => {
  return array[Math.floor(Math.random() * array.length)];
}

export function makeId(length) {
  var result           = '';
  var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for ( var i = 0; i < length; i++ ) {
    result += characters.charAt(Math.random() * charactersLength);
 }
 return result;
}

export function refreshPage() {
  setTimeout(() => {
    window.location.reload();
  }, 300);    
}